import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialHours?: number;
  className?: string;
}
export function CountdownTimer({
  initialHours = 2,
  className = ''
}: CountdownTimerProps) {
  // Set initial time to 2 hours from now
  const [timeLeft, setTimeLeft] = useState(initialHours * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className={`font-mono font-bold tracking-wider ${className}`} data-id="element-46">
      {formatTime(timeLeft)}
    </div>;
}